import React from "react";
import {
  SkeletonWrapper,
  HeroSkeletonWrapper,
  FiltersSkeletonWrapper,
  InsightsSkeletonWrapper,
  HoldingsSkeletonWrapper,
  SkeletonBox,
} from "./styles";

export const LiabilitiesSkeleton: React.FC = () => {
  return (
    <SkeletonWrapper aria-label="Loading liabilities" aria-live="polite">
      {/* Hero summary band: payoff donut, debt remaining, debt-free projection */}
      <HeroSkeletonWrapper>
        <SkeletonBox height="160px" />
      </HeroSkeletonWrapper>

      {/* Filters row: period selector + active-only toggle + count */}
      <FiltersSkeletonWrapper>
        <SkeletonBox width="160px" height="40px" />
        <SkeletonBox width="120px" height="40px" />
        <SkeletonBox width="100px" height="20px" />
      </FiltersSkeletonWrapper>

      {/* Insights panel: debt mix + cost of borrowing */}
      <InsightsSkeletonWrapper>
        <SkeletonBox height="220px" />
      </InsightsSkeletonWrapper>

      {/* Holdings: table on desktop / card list on mobile */}
      <HoldingsSkeletonWrapper>
        <SkeletonBox height="320px" />
      </HoldingsSkeletonWrapper>
    </SkeletonWrapper>
  );
};
